import React from "react";
import LandingPage from "./components/LandingPage";
import UseAutoResize from "./components/UseAutoResize";
import BatchRecorderPage from "./pages/BatchRecorderPage";
import "./App.css";

function App() {
  // URL에서 페이지 결정
  const isRecorderPage = window.location.pathname === "/batch-recorder";

  return (
    <>
      <UseAutoResize />
      <div className="App">
        {isRecorderPage ? <BatchRecorderPage /> : <LandingPage />}
      </div>
    </>
  );
}

export default App;
